import http from './httpService';

let apiEndpoint = '/bannerTexts';

export function getBannerTextByName(name) {
  return http.get(`${apiEndpoint}/${name}`);
}